import React from "react";
import Icon from "./components/Icon";

export default function ChatMessageSearchBar({
  open,
  query,
  onQueryChange,
  resultCount = 0,
  activeIndex = -1,
  onPrev,
  onNext,
  onClose,
  loading = false,
  hint = "Поиск выполняется по уже загруженным сообщениям",
}) {
  if (!open) return null;

  const hasResults = Number(resultCount) > 0;
  const counter = loading
    ? "Ищем..."
    : query?.trim()
      ? hasResults
        ? `${Number(activeIndex) + 1} из ${resultCount}`
        : "Ничего не найдено"
      : hint;

  return (
    <div className="chat-search-panel" role="search" aria-label="Поиск по чату">
      <div className="chat-search-panel__input-wrap">
        <Icon className="chat-search-panel__icon" size={15}>
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </Icon>
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange?.(event.target.value)}
          autoFocus
          placeholder="Найти сообщение, файл или автора..."
        />
        {query ? (
          <button
            type="button"
            className="chat-search-panel__clear"
            aria-label="Очистить поиск"
            onClick={() => onQueryChange?.("")}
          >
            <Icon size={14}>
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </Icon>
          </button>
        ) : null}
      </div>

      <div className="chat-search-panel__meta">{counter}</div>

      <div className="chat-search-panel__actions">
        <button type="button" onClick={onPrev} disabled={!hasResults} aria-label="Предыдущее совпадение">
          <Icon size={15}>
            <polyline points="18 15 12 9 6 15" />
          </Icon>
        </button>
        <button type="button" onClick={onNext} disabled={!hasResults} aria-label="Следующее совпадение">
          <Icon size={15}>
            <polyline points="6 9 12 15 18 9" />
          </Icon>
        </button>
        <button type="button" onClick={onClose} aria-label="Закрыть поиск">
          <Icon size={15}>
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </Icon>
        </button>
      </div>
    </div>
  );
}
